type ConditionalWrapperObj = {
  condition: boolean | string;
  wrapper: (child: React.JSX.Element) => React.JSX.Element;
  children: React.JSX.Element;
};

const ConditionalWrapper = ({ condition, wrapper, children }: ConditionalWrapperObj) =>
  condition ? wrapper(children) : children;

export default ConditionalWrapper;
